import { render, staticRenderFns } from "./FireKey.vue?vue&type=template&id=0b63394b&scoped=true"
import script from "./FireKey.vue?vue&type=script&lang=js"
export * from "./FireKey.vue?vue&type=script&lang=js"
import style0 from "./FireKey.vue?vue&type=style&index=0&id=0b63394b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63394b",
  null
  
)

export default component.exports